// src/components/MobileNav.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiGrid, FiHome, FiArchive, FiSettings } from 'react-icons/fi';
import { FaTicketAlt, FaHardHat } from 'react-icons/fa';

const navItems = [
    { name: 'Dashboard', icon: <FiGrid />, path: '/' },
    { name: 'Tickets', icon: <FaTicketAlt />, path: '/tickets' },
    { name: 'Communities', icon: <FiHome />, path: '/customers' },
    // Swapped Settings for Inventory 
    { name: 'Inventory', icon: <FiArchive />, path: '/inventory' }, 
    { name: 'Technicians', icon: <FaHardHat />, path: '/technicians' },
];

const MobileNav = () => {
    return (
        <nav className="mobile-nav">
            {navItems.map(item => (
                <NavLink
                    key={item.name}
                    to={item.path}
                    className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
                    end={item.path === '/'}
                >
                    <div className="mobile-nav-icon">{item.icon}</div>
                    <span className="mobile-nav-label">{item.name}</span>
                </NavLink>
            ))}
        </nav>
    );
};

export default MobileNav;